import { render, staticRenderFns } from "./juriesAndEvaluators.vue?vue&type=template&id=cf0b43fe"
import script from "./juriesAndEvaluators.vue?vue&type=script&lang=js"
export * from "./juriesAndEvaluators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports